import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTooltipIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_969_58335)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9.99992 16.6663C13.6818 16.6663 16.6666 13.6816 16.6666 9.99967C16.6666 6.31778 13.6818 3.33301 9.99992 3.33301C6.31802 3.33301 3.33325 6.31778 3.33325 9.99967C3.33325 13.6816 6.31802 16.6663 9.99992 16.6663Z",
				stroke: "#50566E",
				strokeWidth: 1.3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 12.6667V10",
				stroke: "#50566E",
				strokeWidth: 1.3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 7.33301H10.0067",
				stroke: "#50566E",
				strokeWidth: 1.3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_969_58335",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(2 2)"
		})
	}) })]
});
export default SvgTooltipIcon;
